/**
 * @generated SignedSource<<38bc22e7256dd713f78c08c4b60d8bec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeoButton_linkData$data = {
  readonly path: string | null;
  readonly isLinkable: boolean | null;
  readonly " $fragmentType": "SeoButton_linkData";
};
export type SeoButton_linkData$key = {
  readonly " $data"?: SeoButton_linkData$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeoButton_linkData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeoButton_linkData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "type": "LinkData",
  "abstractKey": null
};

(node as any).hash = "7d1278475590512cc0a564e9186a15f1";

export default node;
